import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { validate } from "./misc";

import FileUpload from "./FileUpload";
import ErrorAlert from "./ErrorAlert";

class Form extends Component {
    onSubmit = formValues => this.props.onSubmit(formValues);

    displayError({ touched, error }, validationErrorClass = "validation-error--tooltip") {
        let markup = <small className={validationErrorClass}>{error || ""}</small>;

        return touched && error && markup;
    }

    renderInput = ({
        input,
        meta,
        element,
        config,
        validationErrorClass,
        formNoValidate,
        label,
        icon,
        options = [],
        ...rest
    }) => {
        switch (element) {
            case "input":
                return (
                    <div className={`field ${meta.touched && meta.error ? "error" : ""}`}>
                        {label && <label>{label}</label>}

                        {icon && <i className={`${icon}`}></i>}

                        <input {...input} {...config} {...rest} />

                        {!formNoValidate && this.displayError(meta, validationErrorClass)}
                    </div>
                );

            case "select":
                return (
                    <div className={`field ${meta.touched && meta.error ? "error" : ""}`}>
                        {label && <label>{label}</label>}

                        <select {...input} {...config} {...rest}>
                            <option value="">Select One</option>

                            {options.map(({ _id, name, key, value }, idx) => (
                                <option key={idx} value={_id || key}>
                                    {name || value}
                                </option>
                            ))}
                        </select>

                        {this.displayError(meta)}
                    </div>
                );

            case "file":
                return (
                    <div className={`field ${meta.touched && meta.error ? "error" : ""}`}>
                        {label && <label>{label}</label>}

                        <FileUpload {...input} {...config} {...rest} />

                        {!formNoValidate && this.displayError(meta)}
                    </div>
                );

            default:
                return null;
        }
    };

    render() {
        const { handleSubmit, fields = [], errorMessage, submitSucceeded, children } = this.props;

        return (
            <form onSubmit={handleSubmit(this.onSubmit)}>
                {fields.map((field, idx) => (
                    <Field key={idx} {...field} component={this.renderInput} />
                ))}

                {errorMessage && submitSucceeded && <ErrorAlert errorMessage={errorMessage} showErr={submitSucceeded} />}

                {children}
            </form>
        );
    }
}

export default reduxForm({ form: "globalForm", validate })(Form);

/*

->>: BEFORE WE COMPLETELY DEPENDS ON CHILDREN-PROP AND REMOVE SUBMIT-BUTTON:

import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { validate } from "./misc";

import { Button } from "@material-ui/core";
import FileUpload from "./FileUpload";
import ErrorAlert from "./ErrorAlert";

class Form extends Component {
    onSubmit = formValues => this.props.onSubmit(formValues);

    displayError({ touched, error }, validationErrorClass = "validation-error--tooltip") {
        let markup = <small className={validationErrorClass}>{error || ""}</small>;

        return touched && error && markup;
    }

    renderInput = ({ input, meta, element, config, validationErrorClass, label, icon, options = [], ...rest }) => {
        switch (element) {
            case "input":
                return (
                    <div className={`field ${meta.touched && meta.error ? "error" : ""}`}>
                        {label && <label>{label}</label>}

                        {icon && <i className={`${icon}`}></i>}

                        <input {...input} {...config} {...rest} />

                        {!this.props.formNoValidate && this.displayError(meta, validationErrorClass)}
                    </div>
                );

            case "select":
                return (
                    <div className={`field ${meta.touched && meta.error ? "error" : ""}`}>
                        {label && <label>{label}</label>}

                        <select {...input} {...config} {...rest}>
                            <option value="">Select One</option>

                            {options.map(({ _id, name, key, value }, idx) => (
                                <option key={idx} value={_id || key}>
                                    {name || value}
                                </option>
                            ))}
                        </select>

                        {this.displayError(meta)}
                    </div>
                );

            case "file":
                return (
                    <div className={`field ${meta.touched && meta.error ? "error" : ""}`}>
                        {label && <label>{label}</label>}

                        <FileUpload {...input} {...config} {...rest} />

                        {!this.props.formNoValidate && this.displayError(meta)}
                    </div>
                );

            default:
                return null;
        }
    };

    render() {
        const {
            handleSubmit,
            submitText,
            fields = [],
            errorMessage,
            submitSucceeded,
            children,
            submitBtnDisabled = false,
        } = this.props;

        return (
            <form onSubmit={handleSubmit(this.onSubmit)}>
                {fields.map((field, idx) => (
                    <Field key={idx} {...field} component={this.renderInput} />
                ))}

                {errorMessage && submitSucceeded && <ErrorAlert errorMessage={errorMessage} showErr={submitSucceeded} />}

                {!children && submitText ? (
                    <Button type="submit" className="submit-btn" disabled={submitBtnDisabled}>
                        {submitText || "Create"}
                    </Button>
                ) : (
                    children
                )}
            </form>
        );
    }
}

export default reduxForm({ form: "globalForm", validate })(Form);

*/
